import React from "react"
import Navbar from "../layout/Navbar"
import EmotionsFooter from "../components/EmotionsFooter"
import "./DefaultLayout.css" // Import the CSS file for styling

const DefaultLayout = ({ children, leftSidebar }) => {
  return (
    <div className="default-layout">
      <Navbar />
      <div className="main-content">
        {leftSidebar && <div className="left-sidebar">{leftSidebar}</div>}
        <div
          className="main-area"
          style={{
            width: leftSidebar ? "75%" : "100%",
          }}
        >
          {children}
        </div>
      </div>
      <EmotionsFooter />
    </div>
  )
}

export default DefaultLayout
